export const customTabStyles = {
  px: "16px",
  pt: "24px",
  width: "max-content",
  "& .MuiTabs-flexContainer": {
    gap: "24px",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "#257C6D",
    height: "2px",
  },
  "& .MuiTab-root": {
    fontSize: "15px",
    fontWeight: 500,
    lineHeight: "22px",
    color: "#3E3F4C",
    textTransform: "none",
    padding: "0px",
    minHeight: "30px",
    minWidth: "auto",
    overflow: "visible",
    whiteSpace: "nowrap",
  },
  "& .Mui-selected": {
    color: "#257C6D !important",
  },
  "& .Mui-disabled": {
    color: "rgba(0, 0, 0, 0.38) !important",
  },
};

export const tabContentStyles = {
  px: "16px",
  py: "24px",
  overflow: "auto",
  maxHeight: "100%",
  minHeight: 0,
  background: "#fff",
};
